
<template>
  <!-- 2018/12/17 -->
  <el-card class="fitness-index">
    <!-- 添加 -->
    <template>
      <el-tooltip class="margin: 4px" effect="dark" :content="$t('tooltip.back_list')" placement="bottom">
        <el-button
          style="float:left"
          type="success"
          icon="iconfont icon-fitness-chehuisekuai"
          circle
          @click="handleBack()"
        ></el-button>
      </el-tooltip>
      <el-tooltip class="margin: 4px" effect="dark" :content="$t('Store.Contract.New_ContractNumber')" placement="bottom">
        <el-button
          style="float:left"
          type="primary"
          icon="iconfont icon-fitness-tianjiawenjianjia"
          circle
          @click="handleEdit()"
        ></el-button>
      </el-tooltip>
      <el-tooltip class="margin: 4px" effect="dark" :content="$t('Common.save')" placement="bottom">
        <el-button
          style="float:left"
          type="primary"
          icon="iconfont icon-fitness-baocun"
          circle
          @click="postData()"
        ></el-button>
      </el-tooltip>
      <el-switch
        @change="showData()"
        v-model="autoContractNum"
        :active-value="true"
        style="float:right"
        :inactive-value="false"
        :active-text="$t('Store.Contract.CustomNumber')"
        :inactive-text="$t('Store.Contract.no_CustomNumber')"
      ></el-switch>
    </template>
    <el-table :data="tableData" class="my-4" v-loading="loading">
      <el-table-column prop="position" :label="$t('Store.Contract.digit')" align="center"/>
      <el-table-column :label="$t('Store.Contract.Ruledescription')" align="center" width="120">
        <template
          slot-scope="{$index, row}"
        >{{ row.fixed ? '' : '不' }}{{ $t('Store.Contract.fixation') }} {{row.format===1 ? '数字' : "字母"}}{{row.character}}</template>
      </el-table-column>
      <el-table-column prop="format" :label="$t('Store.Contract.char_format')" align="center"/>
      <el-table-column prop="character" :label="$t('Store.Contract.Fixed_character')" align="center"/>
      <el-table-column prop="fixed" :label="$t('Store.Contract.FixedCharacters')" align="center">
        <template slot-scope="{$index, row}" v-if="row.fixed !== ''">
            {{ row.fixed ? $t('Common.yes') : $t('Common.no') }}
        </template>
      </el-table-column>
      <!-- 编辑 -->
      <el-table-column :label="$t('tooltip.edit')" fixed="right" align="center" width="200">
        <template slot-scope="{$index, row}">
          <el-tooltip class="margin: 4px" effect="dark" :content="$t('tooltip.edit')" placement="bottom">
            <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(row)"/>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog
        class="sell-contract-dialog"
        :title="form.position ? '编辑合同编号' : '新增合同编号'"
        :visible.sync="visible">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-width="130px"
            label-suffix=" : "
            label-position="right"
            v-loading="form_loading">
            <el-form-item :label="$t('Store.Contract.FixedCharacters')" prop="fixed">
                <el-radio-group v-model="form.fixed">
                    <el-radio :label="true">{{ $t('Common.yes') }}</el-radio>
                    <el-radio :label="false">{{ $t('Common.no') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Store.Contract.char_format')" prop="format" >
                <el-radio-group v-model="form.format" @change="form.character=''">
                    <el-radio :label='1' >{{ $t('Store.Contract.num0_9') }}</el-radio>
                    <el-radio :label='2' >{{ $t('Store.Contract.Letter(A-Z)') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Store.Contract.Sel_numbers_letters')" prop="character" v-if="form.fixed">
                <el-select
                    v-model="form.character"
                    class="w-full"
                    v-if="form.format===1"
                    clearable >
                    <el-option
                        v-for="(item, index) in number"
                        :key="index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
                <el-select
                    v-model="form.character"
                    class="w-full"
                    v-if="form.format===2"
                    clearable >
                    <el-option
                        v-for="(item, index) in letter"
                        :key="index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-button type="primary" slot="footer" @click="onSubmit">{{ $t('Message.confirm') }}</el-button>
    </el-dialog>
    </el-card>
</template>

<script>
import { Dialog, Switch, Radio, RadioGroup } from 'element-ui';

export default {
    name: 'rules',
    components: {
        ElDialog: Dialog,
        ElSwitch: Switch,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            loading: false,
            form_loading: false,
            tableData: [],
            visible: false,
            forms: [],
            autoContractNum: false,
            form: {
                fixed: '',
                format: '',
                character: null,
            },
            rules: {
                fixed: [
                    { required: true, message: this.$t('Store.Contract.Please_choose'), trigger: 'blur' },
                ],
                format: [
                    { required: true, message: this.$t('Store.Contract.Char_empty'), trigger: 'blur' },
                ],
            },
            number: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
            letter: [
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z',
            ],
            cacheData: [],
        };
    },
    computed: {},
    watch: {
        visible(val) {
            if (!val) {
                this.$refs.form.clearValidate();
                this.form = {
                    fixed: '',
                    format: '',
                    character: '',
                };
            }
        },
    },
    methods: {
        fetchData() {
            this.loading = true;
            API.get(`store/${this.$route.params.id}/contract-num-setting`)
            .then(res => {
                this.autoContractNum = res.autoContractNum;
                this.tableData = res.autoContractNum ? res.rules : [];
                this.cacheData = res.rules;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        handleReset() {
            this.form = {
                id: '',
                position: '',
                desc: '',
                character: '',
                fixed: '',
                format: '',
            };
            this.fetchData(1);
        },
        handleEdit(row) {
            if (row) {
                this.form = row;
            }
            this.visible = true;
        },
        postData() {
            this.loading = true;
            API.put(`store/${this.$route.params.id}/contract-num-setting`, {
                autoContractNum: this.autoContractNum,
                rules: this.cacheData.map(el => {
                    if (!el.character) el.character = null;
                    return el;
                }),
            })
            .then(() => {
                $ele.$message.success(this.$t('Message.save'));
            })
            .finally(() => {
                this.loading = false;
            });
        },
        handleBack() {
            this.$router.back();
        },
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const isEdit = this.form.position;
                if (!isEdit && this.cacheData && this.cacheData.length) {
                    this.form.position = this.cacheData.length + 1;
                } else if (!isEdit && this.cacheData && !this.cacheData.length) {
                    this.form.position = 1;
                }
                if (!isEdit) this.cacheData.push(this.form);
                this.tableData = this.cacheData;
                this.visible = false;
            });
        },
        showData() {
            this.tableData = this.autoContractNum ? this.cacheData : [];
        },
    },
    created() {
        this.fetchData();
    },
};
</script>

<style lang="scss">
.sell-contract-dialog {
    .el-dialog {
        width: 650px;
    }
}
</style>
